<ng-container *ngIf="routerEvents$ | async" />
<div class="st-side-bar flex flex-column align-items-center">
  <div
    class="show-hide-toggle"
    [ngClass]="{ 'show-hide-toggle-active': isExpandedMenu() }"
  >
    <button
      (click)="expandMenu()"
      type="button"
    >
      <em class="ph ph-list"></em>
    </button>
  </div>
  <div
    class="st-side-bar-content flex-1 flex flex-column align-items-center gap-spacing-md"
  >
    @for (item of dashboardRoutes(); track $index) {
      <z-icon-button [navigationItem]="item" />
    }
    @if (dashboardRoutes().length && navigationList().length) {
      <div class="side-divider"></div>
    }
    <div
      class="inner-section flex flex-column align-items-center gap-spacing-md flex-1"
    >
      <div
        class="navigation-section flex flex-column align-items-center gap-spacing-md"
      >
        @for (nav of navigationList(); track $index) {
          <z-icon-button [navigationItem]="nav" />
        }
      </div>
      @if (!this.hideTools() && this.tools().length) {
        <div class="side-divider"></div>
        <div class="apps-section">
          <z-apps-tools-menu [tools]="tools()" />
        </div>
      }
      <div
        class="profile-setting-section flex flex-column align-items-center gap-12px mt-auto"
      >
        <a
          class="profile-section cursor-pointer"
          (click)="profileMenu.toggle($event)"
          [title]="profile().userName"
        >
          <img
            [src]="userImage()"
            alt=""
          />
        </a>
        <p-menu
          #profileMenu
          [model]="profileMenuItems()"
          [popup]="true"
          appendTo="body"
        />
        @if (!isStandAlonePortal()) {
          <div class="side-divider"></div>
          <z-multi-settings-menu />
        } @else if (isStandAlonePortal() && settingsRoutes().children.length) {
          <div class="side-divider"></div>
          <a class="setting-section">
            <z-icon-button [navigationItem]="settingsRoutes()" />
          </a>
        }
      </div>
    </div>
  </div>
</div>
